import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import logoSvg from '../../../../assets/brand/logo_site.svg';
import { NOT_FOUND_TEXT } from '../constants/notFound404Text';
import colors from '../../../design-system/colors';

export default function NotFound404Logo(): JSX.Element {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', mb: 1 }}>
            <img src={logoSvg} alt={NOT_FOUND_TEXT.LOGO_ALT} style={{ width: 25, height: 40 }} />
            <Typography
                sx={{
                    fontFamily: 'Outfit, sans-serif',
                    fontWeight: 500,
                    fontSize: '20px',
                    color: colors.neutral.white,
                    lineHeight: 1,
                }}
            >
                {NOT_FOUND_TEXT.BRAND_NAME}
            </Typography>
        </Box>
    );
}
